<template>
  <div>
    <CCard>
      <div
        v-if="isLoading"
        :style="{ height: '80vh' }"
        class="d-flex flex-column justify-content-center align-items-center"
      >
        <CSpinner
          style="width:4rem;height:4rem;"
          color="info"
          grow
        />
      </div>
      <div v-else>
        <CCardHeader data-cy="header">
          <CIcon name="cil-tags" /> Categories
          <CButton
            class="float-right"
            data-cy="button-create-Categories"
            size="sm"
            color="info"
            @click="$router.push({ name: 'CategoryCreate', exact: true })"
          >
            <CIcon
              size="sm"
              name="cil-plus"
            /> Create New
          </CButton>
        </CCardHeader>
        <CCardBody>
          <div class="d-flex align-items-center mb-3">
            <CSwitch
              variant="3d"
              color="primary"
              horizontal
              size="sm"
              :checked.sync="includeTestOnly"
              class="mr-2"
            />

            <h5 class="m-0">
              Include Test Only Categories
            </h5>
          </div>

          <CDataTable
            data-cy="table-Categories"
            small
            fixed
            border
            sorter
            column-filter
            :items="customSortedItems"
            :fields="fields"
            :items-per-page="50"
            :pagination="{align: 'center'}"
            :sorter-value.sync="sorterColumn"
          >
            <template #status="{item}">
              <td>
                <CBadge :color="getBadge(item.status)">
                  {{ item.status }}
                </CBadge>
              </td>
            </template>

            <template #id="{item}">
              <td>
                {{ item.id }}
                <CBadge
                  v-if="item.testOnly"
                  color="danger"
                  class="ml-2"
                >
                  Test
                </CBadge>
              </td>
            </template>

            <template #isPublic="{item}">
              <td>
                <BooleanBadge :boolean-value="!item.isPrivate" />
              </td>
            </template>

            <template #parentCategory="{item}">
              <td>
                {{ item.parentCategory.name }}
              </td>
            </template>

            <template #parentCategoryStatus="{item}">
              <td>
                <CBadge :color="getBadge(item.parentCategory.status)">
                  {{ item.parentCategory.status }}
                </CBadge>
              </td>
            </template>

            <template #bidModifiers="{item}">
              <td>
                <BidModifiersBadge
                  :category="item.bidModifiers"
                  :show-category-prefix="false"
                  :min-profit-amount="item.bidPreferences && item.bidPreferences.minProfitAmount"
                />
              </td>
            </template>

            <template #languages="{item}">
              <td>
                <span
                  v-for="(ts, $idx) in item.languages"
                  :key="ts.id"
                >
                  {{ ts.name }}
                  <span
                    v-if="$idx !== item.languages.length - 1"
                    class="mx-2"
                  >|</span>
                </span>
              </td>
            </template>

            <template #Actions="{item}">
              <td>
                <router-link
                  data-cy="link-edit-item"
                  :to="{
                    name: 'CategoryEdit',
                    params: { id: item.id },
                    exact: true
                  }"
                >
                  <CIcon name="cil-pencil" />
                </router-link>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </div>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getBadge } from '@/components/common/Table.vue'
import testOnlyItemsMixin from '@/mixins/test-only-items-mixin'
import BidModifiersBadge from '@/components/BidModifiersBadge.vue'

export default {
  name: 'Categories',

  title: 'Categories',

  components: {
    BidModifiersBadge
  },

  mixins: [testOnlyItemsMixin],

  data() {
    return {
      isLoading: false,

      sorterColumn: { column: 'name', asc: true },

      fields: [
        { key: 'status', label: 'Status', sortable: true },
        { key: 'parentCategoryStatus', label: 'Parent Status' },
        { key: 'isPublic', label: 'Public', sortable: true },
        { key: 'id', label: 'ID', sortable: true },
        { key: 'parentCategory', label: 'Parent', sortable: true },
        { key: 'name', sortable: true },
        { key: 'bidModifiers', label: 'Bid Modifiers', sorter: false, filter: false },
        { key: 'languages', label: 'Languages', sorter: false },
        { key: 'Actions', filter: false }
      ]
    }
  },
  computed: {
    ...mapState('category', {
      items: 'categories'
    }),

    customSortedItems() {
      if (this.sorterColumn.column === 'parentCategory') {
        const items = [...this.filteredItems]

        return items.sort((itemA, itemB) => {
          return String.prototype.localeCompare.call(itemA.parentCategory.name, itemB.parentCategory.name) * (this.sorterColumn.asc ? 1 : -1)
        })
      }

      return this.filteredItems
    }
  },
  async created() {
    this.isLoading = true
    await this.list()
    this.isLoading = false
  },
  methods: {
    ...mapActions('category', ['list']),

    getBadge
  },
}
</script>
<style lang="scss" scoped></style>
